import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { splitPath } from "../../lib/i18nRoutes";

// Resets scroll to top on every route change. Place inside <BrowserRouter>.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  // A language switch keeps the same page — don't jump to the top.
  const page = splitPath(pathname).rest;

  useEffect(() => {
    // Instant jump on every route change (no animation).
    // Some browsers reject 'instant' value; fall back to 'auto'.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [page]);

  return null;
};
